$(document).ready(function () {
  
function advHeaderCarousel() {
  var checkWidth = $(window).width();
  var owlItem = $(".advs_header .row");
  var advBoxHeader = $(".site-header .advs_header .advs-box");
  var advBoxFooter = $(".footer .advs_header .advs-box");
  
  if (checkWidth > 1024) {
      owlItem.trigger('destroy.owl.carousel');
      owlItem.removeClass('owl-carousel');
    
    if(advBoxHeader.length > 3){
      advBoxHeader.parent().addClass('owl-carousel');
      advBoxHeader.parent().owlCarousel({
        items: 3,
        animateOut: 'fadeOut',
        touchDrag: true,
        mouseDrag: true,
        dots: false,
        loop: true,
        autoplay:true,
        autoplayTimeout:3000
      });
    }

    if(advBoxFooter.length > 3){
      advBoxFooter.parent().addClass('owl-carousel');
      advBoxFooter.parent().owlCarousel({
        items: 3,
        animateOut: 'fadeOut',
        touchDrag: true,
        mouseDrag: true,
        dots: false,
        loop: true,
        autoplay:true,
        autoplayTimeout:3000
      });
    }
    
  } else if (checkWidth < 1025) {
    advBoxHeader.parent().trigger('destroy.owl.carousel');
    advBoxFooter.parent().trigger('destroy.owl.carousel');
    advBoxHeader.parent().removeClass('owl-carousel');
    advBoxFooter.parent().removeClass('owl-carousel');
    
    owlItem.addClass('owl-carousel');
    owlItem.owlCarousel({
      items: 1,
      margin: 15,
      touchDrag: true,
      mouseDrag: true,
      dots: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:3000,
      responsive :{
        0:{
          items: 1,
        },
        768:{
          items: 2,
          margin: 25,
        }
      }
    });
  }
  
}

   var pathname = location.pathname;
     var href = location.href;
    $('#top-menu>li .dropdown-item').each(function(){
        var $this = $(this);

        if($this.attr('href') == pathname || $this.attr('href') == href ){
            $this.parent('li').addClass('active');
        }
    })

advHeaderCarousel();
$(window).resize(advHeaderCarousel);
})